import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';

const FormInput = (props) => {
  const {
    label,
    error,
    onChange,
    value,
    type,
    name,
    style,
    className,
    readOnly,
    disabled,
    as,
  } = props;

  return (
    <div className="mb-2">
      <FloatingLabel controlId={name} label={label} className={className}>
        <Form.Control
          onChange={onChange}
          value={value}
          type={type}
          placeholder={label}
          isInvalid={!!error}
          style={style}
          readOnly={readOnly}
          disabled={disabled}
          as={as}
        />
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      </FloatingLabel>
    </div>
  );
};

FormInput.defaultProps = {
  readOnly: false,
  disabled: false,
  as: 'input',
  type: 'text',
};

export default FormInput;
